import { render, staticRenderFns } from "./ModalTypology.vue?vue&type=template&id=15cf4026&"
import script from "./ModalTypology.vue?vue&type=script&lang=js&"
export * from "./ModalTypology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports